export const strings = {
    prefixAgo: 'πριν',
    prefixFromNow: 'σε',
    suffixAgo: '',
    suffixFromNow: '',
    seconds: 'λιγότερο από ένα λεπτό',
    minute: 'περίπου ένα λεπτό',
    minutes: '%d λεπτά',
    hour: 'περίπου μία ώρα',
    hours: 'περίπου %d ώρες',
    day: 'μία μέρα',
    days: '%d μέρες',
    month: 'περίπου ένα μήνα',
    months: '%d μήνες',
    year: 'περίπου ένα χρόνο',
    years: '%d χρόνια',
};
